import {Stack} from 'shells/layout/stack/stack';
import {LoadingPage} from 'shells/loading-page/loading-page';
import {Body} from 'shells/typography/body';

import type {Audience as AudienceFragment} from 'nutshell-graphql-types';

import type {ReportURLParams} from '../../reports/report-types';

import {AudienceEngagementStats} from './engagement/audience-engagement-stats';
import {AudienceLatestOutreach} from './latest-outreach/audience-latest-outreach';
import {CurrentAudienceMembers} from './membership/current-audience-members';
import {AudienceMembershipReport} from './reports/audience-membership-report';

type Props = {
    audience: AudienceFragment | null | undefined;
    onParamChange: (arg1: any, arg2: boolean) => any;
    onParamPush: (arg1: any, arg2: boolean) => any;
    urlParams: ReportURLParams<'contacts'>;
    isLoading: boolean;
};

export function AudiencePageInfoNew(props: Props) {
    if (!props.audience) {
        return <LoadingPage />;
    }

    return (
        <Stack spacing={24}>
            <Stack spacing={12}>
                <CurrentAudienceMembers audience={props.audience} />
                <AudienceMembershipReport
                    audience={props.audience}
                    urlParams={props.urlParams}
                    onParamChange={props.onParamChange}
                    onParamPush={props.onParamPush}
                />
            </Stack>
            <Stack spacing={16}>
                <Body size='normal' color='dark' isBold={true}>
                    Channel campaign breakdown
                </Body>
                <div className={'flex full-width'}>
                    <AudienceEngagementStats audienceId={props.audience.id} />
                </div>
            </Stack>
            <Stack spacing={16}>
                <Body size='normal' color='dark' isBold={true}>
                    Latest outreach
                </Body>
                <AudienceLatestOutreach audience={props.audience} />
            </Stack>
        </Stack>
    );
}
